import { http } from '../api/http';

export type MfaPurpose =
  | 'BANK_ACCOUNT_CREATE'
  | 'BANK_ACCOUNT_UPDATE'
  | 'WITHDRAWAL_REQUEST'
  | 'INVESTMENT_PAYMENT'
  | 'CRITICAL_ACTION';

export const MfaService = {
  sendCode(purpose?: MfaPurpose) {
    return http<{ message: string; expiresIn?: string }>('/auth/mfa/send-code', {
      method: 'POST',
      body: purpose ? { purpose } : undefined
    });
  },

  verifyCode(code: string, purpose?: MfaPurpose) {
    return http<{ verified: boolean; message: string }>('/auth/mfa/verify-code', {
      method: 'POST',
      body: { code, ...(purpose ? { purpose } : {}) }
    });
  },
};
